import { get } from '@web3/base-utils';
import { GetChainListRes } from '@/types/chain';

/** 获取链余额 */
export const getChainList = () => {
  return get<GetChainListRes>('/web3/wallet/v1/private/mgmt/chain/list');
};
